export const linksToShare = {
  facebook: 'https://www.facebook.com/sharer.php?u=%{url}',
  twitter: 'https://www.twitter.com/share?url=%{url}',
  pinterest: 'https://www.pinterest.com/pin/create/button/?url=%{url}',
  linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=%{url}',
  wechat: 'https://www.shareaholic.com/share/wechat/?link=%{url}',
  vkontakte: 'https://vk.com/share.php?url=%{url}',
  weibo: 'http://service.weibo.com/share/share.php?url=%{url}&title=%{title}',
  email: `mailto:?subject=RHG ${global.document.title}&body=%{url}`,
  whatsapp: 'https://api.whatsapp.com/send?text=%{url}'
}
